import React, {useEffect, useState} from 'react';
import {Formik, Form, Field} from 'formik';
import {useUser} from "../../../contexts/UserContext";
import FieldCustom from "../../Field/FieldCustom";
import styles from "../../../pages/Admin/Admin.module.css";
import AxiosConfig from "../../../services/AxiosConfig";
import {useModal} from "../../../contexts/ModalContext";
import {Link, useNavigate} from "react-router-dom";
import FieldCheckbox from "../../Field/FieldCheckbox";
import FieldCheckboxArray from "../../Field/FieldCheckboxArray";
import BtnSave from "../../Button/BtnSave";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faArrowLeftLong, faExternalLink} from "@fortawesome/free-solid-svg-icons";
import {getUtilisateurRoleLabel} from "../../../services/UserService";
import {ReactComponent as AnnulerIcone} from "../../../icons/annuler.svg";
import Routing from "../../../services/routing";

function JustificatifTypeCreation({ justificatifType }) {
    const {user} = useUser();
    const {showModal, hideModal} = useModal();
    const formikRef = React.useRef();
    const [roles, setRoles] = useState([]);
    const initialRoles = justificatifType?.justRole || [];
    let navigate = useNavigate();

    const initialValues = {
        label: justificatifType?.justLabel || "",
        selectedRoles: initialRoles || [],
        obligatoire: justificatifType?.justObligatoire || false,
        justificatif: justificatifType?.justId || "",
        desactiver: justificatifType?.justActif === false,
    };

    const handleSuccess = (children = "Enregistrée avec succès") => {
        showModal('success', {children: children, timeout: 5000});
    };
    const handleError = (children = "Une erreur est survenue") => {
        showModal('error', {children: children, timeout: 5000});
    };

    const handleSubmit = async (values, {setSubmitting}) => {
        try {
            const response = await AxiosConfig.post(`/admin/justificatifs/types/creation`, values);

            if (response.data.success) {
                handleSuccess();
                navigate(`/admin/justificatifs/types/${response.data.id}`);
            } else {
                console.error('error', response.data);
                handleError("Erreur : "+ response.data.message);
            }
        } catch (error) {
            console.error('error', error);
            handleError();
        }
    }

    useEffect(() => {
        const fetchRoles = async () => {
            const response = await AxiosConfig.get(`/admin/roles`);
            if (response.data.success) {
                setRoles(response.data.myRoles);
            } else {
                console.error('error', response.data);
                handleError("Erreur lors de la récupération des rôles");
            }
        }
        fetchRoles();
    }, []);

    return (
        <div style={{margin: '0 0 50px 0'}}>
            {Object.keys(initialValues).length > 0 ? (
                <Formik
                    initialValues={initialValues}
                    onSubmit={handleSubmit}
                    enableReinitialize
                    innerRef={formikRef}
                >
                    {({ isSubmitting, setFieldValue, values }) => {
                        const handleCheckboxChange = (role, isChecked) => {
                            if (isChecked) {
                                setFieldValue("selectedRoles", [...values.selectedRoles, role]);
                            } else {
                                setFieldValue(
                                    "selectedRoles",
                                    values.selectedRoles.filter((selectedRole) => selectedRole !== role)
                                );
                            }
                        };

                        return (
                            <Form className={styles.viewBloc}>
                                <div className={styles.formBloc}>
                                    <FieldCustom type={"text"} name={"label"} label={"Label"}/>

                                    <div style={{
                                        display: "flex",
                                        flexDirection: "column",
                                        padding: "10px",
                                        margin: "10px 0",
                                        width: "100%",
                                        backgroundColor: "#e6efeb"
                                    }}>
                                        <h3>Rôles</h3>
                                        {roles.map((role, index) => (
                                            <FieldCheckboxArray
                                                key={index}
                                                name={"selectedRoles"}
                                                label={getUtilisateurRoleLabel(role.role)}
                                                value={role.role}
                                                id={`${role.role}`}
                                                onChange={(e) => handleCheckboxChange(role.role, e.target.checked)}
                                            />
                                        ))}
                                        <Link to={Routing.routes.adminRoles} className={styles.btnAdd}>
                                            Gérer les rôles <FontAwesomeIcon icon={faExternalLink}/>
                                        </Link>
                                    </div>
                                </div>

                                <FieldCheckbox name={"obligatoire"} label={"Obligatoire"}/>

                                <FieldCheckbox name={"desactiver"} label={"supprimer ce justificatif"}/>

                                <Field type={"hidden"} name={"justificatif"}/>

                                <div className={"barre_btn"}>
                                    <button type={"button"} onClick={() => {
                                        navigate(-1)
                                    }} className={"btn btn_danger"}><AnnulerIcone/>Annuler
                                    </button>
                                    <BtnSave isSubmitting={isSubmitting}/>
                                </div>
                            </Form>
                        )
                    }
                    }
                </Formik>
                ) :
                (<p>Chargement...</p>)
            }

        </div>);
}

export default JustificatifTypeCreation;